import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import _ from 'lodash';
import { WItem } from './WItem';

export class WItemEDI extends TrackableEntity {
    id: number = 0;
    //forCloud
    custType: string = '';
    //custName: string = '';
    //filePath: string | null = null;
    fileName: string | null = null;
    fileCount: number = 0;

    scanItem: Array<any> = [];
    locResult: Array<any> = [];
    itemResult: Array<any> = [];
    container: Array<WItem> = [];
    

    constructor(init?:Partial<WItemEDI>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'custType','custName','filePath','fileName','fileCount','scanItem','locResult','itemResult');
        if(this.id === 0) this.id = this.GetNextId();
        if(this.container.length > 0) {
            // for(let i = 0; i < this.container.length; i++) {
            //     this.container.splice(i, 1, new WReceiveItem(this.container[i]));
            // }
            this.container = this.container.map(d => new WItem(d));
        } else {
            this.container = [];
        }
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(WItemEDI.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = WItemEDI.dicFieldMappings[m];
        });
        _.keys(WItem.dicFieldMappings).forEach(m=>{
            dicFieldMap[`container.${m}`] = WItem.dicFieldMappings[m];
        });
        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_WITEM' }),
        'custType': new DBMappingInfo({ field: 'F_CENTER_NO', table: 'T_WITEM' }),
    };
    setChildTrackable(value: boolean): void {
        if(this.container.length > 0) {
            this.container.forEach(c => c.trackable = value);
        }
    }
}
